import { useMutation, useQueryClient } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

export function useUpdateExternalUser2fa() {
  const { getFetchConfig } = useGetFetchConfig();
  const client = useQueryClient();

  return useMutation<void, Error, boolean>(
    async (enabled) => {
      const response = await fetch(
        `${APIBaseChronos}/api/org/require-external-user-2fa`,
        getFetchConfig({ method: FetchMethod.PATCH, data: { enabled } }),
      );
      if (!response.ok) throw new Error('Failed to update two-factor authentication setting');
    },
    {
      onSuccess: () => {
        void client.invalidateQueries([QueryEntity.User]);
        void client.invalidateQueries([QueryEntity.OrganisationById]);
      },
    },
  );
}
